(function (HafasWebapp) {

  var mapSearchTemplate = "TP_TplMapSearch";
  var mapSearchTemplateFile = "map.search.html";
  var mapSearchTargetContainerId = "#HFS_MapSearchContainer";

  var mapSearchMobileTemplate = "TP_TplMapSearchMobile";
  var mapSearchMobileTargetContainerId = "#HFS_MapSearchMobileContainer";

  function MapSearchController() {

    this.suggest = null;
    this.target = null;
    this.blurTimeout = null;

    this.init = function () {
      this.target = Hafas(mapSearchTargetContainerId);
      if (this.target === null) {
        Hafas.logger.error(Hafas.logger.ERROR_TYPES.JS, "mapsearch.init", "Render target not found! id: " + mapSearchMobileTargetContainerId);
        return;
      }
      this.render();
      this.updateViewState();
      if (Hafas.Config.MapSearch.useSmallStyle) {
        this.toSmallMode();
      }
    }

    this.render = function () {
      var html = Hafas.Modules.Render.renderTemplate(mapSearchTemplate, {});
      this.target.innerHTML = html;
      this.postRender();
    }

    /**
     * Wird nach jedem Rendern ausgeführt
     */
    this.postRender = function () {
      this.suggest = Hafas.Core.newType('hafasSuggest', {
          input: "MapSearch",
          type: "S",
          config: {
            "useChooseFromMap": false
          },
          useAlternativeHolder: true,
          onSelect: this.onLocationSelect.bind(this),
          onShow: this.onShowSuggest.bind(this),
          onHide: this.onHideSuggest.bind(this),
          onFocus: this.onFocusSuggestInput.bind(this),
          onBlur: this.onBlurSuggestInput.bind(this)
        }
      );

      var button = Hafas("#HFS_MapSearchButton");
      button.addEventListener("click", this.onSearchButtonClick.bind(this));
    }

    /**
     * Eine Location wurde im Suggest aufgewählt.
     * @param location
     */
    this.onLocationSelect = function (location) {
      if (Hafas.Config.MapSearch.useSmallStyle) {
        this.startBlurTimeout();
      }
      Hafas.ps.pub('/map/createLocationSelection', [location, 14]);
    }

    this.onShowSuggest = function () {
      this.target.classList.add("js_suggestShown");
    }

    this.onHideSuggest = function () {
      this.target.classList.remove("js_suggestShown");
    }

    this.onFocusSuggestInput = function () {
      this.target.classList.add("js_hasFocus");

      if (Hafas.Config.MapSearch.useSmallStyle) {
        this.resetBlurTimeout();
        this.toOpenMode();
      }
    }

    this.onBlurSuggestInput = function () {
      this.target.classList.remove("js_hasFocus");

      if (Hafas.Config.MapSearch.useSmallStyle) {
        this.startBlurTimeout();
      }
    }

    /**
     * Ein Klick auf den Lupenbutton
     */
    this.onSearchButtonClick = function () {

      if (Hafas.Config.MapSearch.useSmallStyle) {
        this.toOpenMode();
      } else {
        var location = this.suggest.getLocation();
        if (location) {
          this.onLocationSelect(location);
        }
      }

      this.suggest.focus();
    }

    this.startBlurTimeout = function () {
      this.resetBlurTimeout();

      this.blurTimeout = setTimeout(function () {
        this.toSmallMode();
        this.blurTimeout = null;
      }.bind(this), 1000);
    }

    this.resetBlurTimeout = function () {
      if (this.blurTimeout) clearTimeout(this.blurTimeout);
    }

    /**
     * Aktualisiert den Status von MapSearch. Bedeutet: Soll es groß, oder als kleiner Button angezeigt werden?
     */
    this.updateViewState = function () {
      if (this.isSideDrawerVisible()) {
        this.toSmallMode();
        this.target.classList.add("js_besideMapOptions");
      } else {
        if (!Hafas.Config.MapSearch.useSmallStyle) {
          this.toOpenMode();
        }
        this.target.classList.remove("js_besideMapOptions");
      }
    }

    /**
     *
     */
    this.toOpenMode = function () {
      this.target.classList.remove("js_showSmall");
      this.suggest.setDisabled(false);
    }

    /**
     * Der MapSearch Container wird nur als kleiner Button mit Lupe angezeigt.
     */
    this.toSmallMode = function () {
      this.target.classList.add("js_showSmall");
      this.suggest.setDisabled(true);
      this.target.classList.remove("js_hasFocus");
    }

    /**
     * Sind die Map Optionen geöffnet?
     * @returns {boolean}
     */
    this.isSideDrawerVisible = function () {
      var sideDrawer = Hafas("#HFS_PageSideDrawerTrigger");
      return sideDrawer && sideDrawer.classList.contains("js_sideDrawerOpened");
    }

  }

  function MapSearchMobileController() {
    this.suggest;
    this.target;

    this.init = function () {
      var mapActionBarContent = Hafas("#HFS_MapActionbarContent");
      if (mapActionBarContent === null) {
        return;
      }
      this.target = mapActionBarContent;
      this.render();
    }

    this.show = function () {
      var mapActionBarContent = Hafas("#HFS_MapActionbarContent");
      var mapActionBarHeader = Hafas("#HFS_MapActionbarHeader");
      var mapActionBarBackBtn = Hafas("#HFS_MapActionbarBack");
      var mapSearchButtonMobile = Hafas("#HFS_MapSearchMobilButton");
      var mapCloseSearchButtonMobile = Hafas("#HFS_MapSearchClose");
      var mapOptionsButtonMobile = Hafas("#HFS_MapOptioneMobileButton");
      mapActionBarContent.classList.add("js_show");
      mapActionBarHeader.classList.add("js_hide");
      mapActionBarBackBtn.classList.add("js_hide");

      mapCloseSearchButtonMobile.classList.remove("js_hide");
      mapCloseSearchButtonMobile.classList.add("js_show");

      if (mapSearchButtonMobile) mapSearchButtonMobile.style.display = "none";
      if (mapOptionsButtonMobile) mapOptionsButtonMobile.style.display = "none";

      this.suggest.focus();
    }

    this.render = function () {

      var html = Hafas.Modules.Render.renderTemplate(mapSearchMobileTemplate, {});
      this.target.innerHTML = html;
      this.postRender();
    }

    this.postRender = function () {
      this.suggest = Hafas.Core.newType('hafasSuggest', {
          input: "MapSearchMobile",
          type: "S",
          config: {
            "useChooseFromMap": false
          },
          useAlternativeHolder: true,
          onSelect: this.onLocationSelect.bind(this)
        }
      );

      var searchByTextButton = Hafas("#HFS_MapSearchByTextButton");
      if (searchByTextButton) searchByTextButton.addEventListener("click", this.onSearchByText.bind(this));
    }

    this.hide = function () {
      var mapActionBarContent = Hafas("#HFS_MapActionbarContent");
      var mapActionBarHeader = Hafas("#HFS_MapActionbarHeader");
      var mapActionBarBackBtn = Hafas("#HFS_MapActionbarBack");
      var mapSearchButtonMobile = Hafas("#HFS_MapSearchMobilButton");
      var mapCloseSearchButtonMobile = Hafas("#HFS_MapSearchClose");
      var mapOptionsButtonMobile = Hafas("#HFS_MapOptioneMobileButton");
      mapActionBarContent.classList.remove("js_show");
      mapActionBarHeader.classList.remove("js_hide");
      mapActionBarBackBtn.classList.remove("js_hide");

      mapCloseSearchButtonMobile.classList.remove("js_show");
      mapCloseSearchButtonMobile.classList.add("js_hide");

      if (mapSearchButtonMobile) mapSearchButtonMobile.style.display = "";
      if (mapOptionsButtonMobile) mapOptionsButtonMobile.style.display = "";
    }

    /**
     * Eine Location wurde im Suggest aufgewählt.
     * @param location
     */
    this.onLocationSelect = function (location) {
      Hafas.ps.pub('/map/createLocationSelection', [location, 14]);
      this.hide();
    }

    this.onSearchByText = function () {
      this.suggest.validateLocation(true);
      this.hide();
    }
  }


  var mapSearchController = new MapSearchController();
  var mapSearchMobileController = new MapSearchMobileController();

  HafasWebapp.prototype.Controller.MapSearch = {
    init: function () {
      if (!Hafas.Config.MapSearch.use) return;

      Hafas.Modules.Loader.loadTemplateFiles([mapSearchTemplateFile], function () {
        mapSearchController.init();
      });

    },
    initMobile: function () {
      if (!Hafas.Config.MapSearch.use) return;

      Hafas.Modules.Loader.loadTemplateFiles([mapSearchTemplateFile], function () {
        mapSearchMobileController.init();
      });
    },
    onSidedrawerChanged: function () {
      if (!Hafas.Config.MapSearch.use) return;

      mapSearchController.updateViewState()
    },
    showMobile: function () {
      if (!Hafas.Config.MapSearch.use) return;

      mapSearchMobileController.show();
    },
    hideMobile: function () {
      mapSearchMobileController.hide();
    }
  };

})(HafasWebapp);




